import { ColumnDef } from "@tanstack/table-core/build/lib/types";
import { StpDetails } from "../../graphql/graphql";

export type StpDetailsTableColumn<T> = ColumnDef<T, any> & {
  accessorKey: keyof T | string;
  header: string | React.ReactNode | (() => React.ReactNode);
};

export const getStpDetailsTableColumns = (): StpDetailsTableColumn<StpDetails>[] => [
  {
    header: () => <span title="STP Code">STP Code</span>,
    accessorKey: "stpCode",
    cell: ({ row }) => row.original.stpCode ?? "N/A",
  },
  {
    header: () => <span title="Authority Reporting Code">Authority Reporting Code</span>,
    accessorKey: "authorityReportingCode",
    cell: ({ row }) => row.original.authorityReportingCode ?? "N/A",
  },
  {
    header: () => <span title="Effective From">Effective From</span>,
    accessorKey: "effectiveFrom",
    cell: ({ row }) => row.original.effectiveFrom ? new Date(row.original.effectiveFrom).toLocaleDateString() : "N/A",
  },
  {
    header: () => <span title="Effective To">Effective To</span>,
    accessorKey: "effectiveTo",
    cell: ({ row }) => row.original.effectiveTo ? new Date(row.original.effectiveTo).toLocaleDateString() : "N/A",
  },
  {
    header: () => <span title="Final Decision">Final Decision</span>,
    accessorKey: "finalDecision",
    cell: ({ row }) => row.original.finalDecision ?? "N/A",
  },
  {
    header: () => <span title="Final Decision Date">Final Decision Date</span>,
    accessorKey: "finalDecisionDate",
    cell: ({ row }) => row.original.finalDecisionDate ? new Date(row.original.finalDecisionDate).toLocaleDateString() : "N/A",
  },
];